import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";

import { AuthAndPersonalDetailsFormFields } from "@/components/Onboarding/Steps/PersonalDetails/personalDetails.types";
import {
  BusinessPersonalDetailsFormFields,
  PersonalDetailsFormFieldKeys,
} from "@/components/Onboarding/Steps/PersonalDetails/PersonalDetailsFormFields/PersonalDetailsFormFields";
import { useCustomerData } from "@/components/Onboarding/Steps/PersonalDetails/useCustomerState";
import { SCHWEIZ } from "@/constants/countries";
import { DataContext } from "@/provider/DataContextProvider";
import { transformBasicCustomerDataToPersonalDetailsForm } from "@/utils/customerUtils";

export const usePersonalDetailsForm = () => {
  const { dataContext } = useContext(DataContext);

  const defaultValues: AuthAndPersonalDetailsFormFields = {
    email: "",
    password: "",
    passwordRepeat: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    formOfAddress:
      dataContext.personalDetails?.formOfAddress?.toString() || "0",
    street: "",
    houseNumber: "",
    zip: "",
    city: "",
    organizationId: "",
    organizationForm: { id: -1, description: "" },
    organizationName: "",
    country: SCHWEIZ,
    ...dataContext.personalDetails,
    phone: dataContext.personalDetails?.phone || "+41",
  };

  const formMethods = useForm<AuthAndPersonalDetailsFormFields>({
    mode: "onChange",
    defaultValues,
  });

  const { customerHasPersonalDetails, customerData } = useCustomerData();

  useEffect(() => {
    if (!!customerData && customerHasPersonalDetails) {
      const formPrefillData =
        transformBasicCustomerDataToPersonalDetailsForm(customerData);

      Object.keys(formPrefillData).forEach((key) => {
        formMethods.setValue(
          key as keyof Omit<BusinessPersonalDetailsFormFields, "terms">,
          formPrefillData[
            key as keyof Omit<BusinessPersonalDetailsFormFields, "terms">
          ],
          { shouldDirty: false, shouldTouch: false },
        );
      });

      formMethods.trigger(Object.values(PersonalDetailsFormFieldKeys));
    }
  }, [customerHasPersonalDetails, customerData, formMethods]);

  const formValues = formMethods.watch();

  return { formMethods, formValues };
};
